import { render, staticRenderFns } from "./DashboardGrid.vue?vue&type=template&id=71a4660e&"
import script from "./DashboardGrid.vue?vue&type=script&lang=js&"
export * from "./DashboardGrid.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGrid.vue?vue&type=style&index=0&id=71a4660e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports